/**
 * Chemins d'authentification Entrea — web, mobile natif, portail admin.
 */

import { isPortalAdminPath, PORTAL_LOGIN_PATH } from './portalAdminNav';

export const WEB_LOGIN_PATH = '/login';
export const MOBILE_LOGIN_PATH = '/mobile/login';
export const WEB_FIRST_LOGIN_PASSWORD_PATH = '/first-login-password';
export const MOBILE_FIRST_LOGIN_PASSWORD_PATH = '/mobile/first-login-password';
export const MOBILE_UNLOCK_PATH = '/mobile/unlock';
export const MOBILE_SETUP_PIN_PATH = '/mobile/setup-pin';

const MOBILE_AUTH_PREFIX = '/mobile';

/** Routes du parcours mobile (login, PIN, premier mot de passe, …). */
export function isMobileAuthPath(pathname) {
  return typeof pathname === 'string' && pathname.startsWith(MOBILE_AUTH_PREFIX);
}

/** Viewport téléphone / petite tablette — aligné Tailwind `md` (768px). */
export function isMobileViewport() {
  if (typeof window === 'undefined') return false;
  try {
    return window.matchMedia('(max-width: 767px)').matches;
  } catch {
    return window.innerWidth < 768;
  }
}

/**
 * Page de connexion pour les redirections 401 / session expirée.
 * Respecte le périmètre courant (portail admin vs mobile vs web).
 */
export function resolveLoginPath(pathname) {
  if (isPortalAdminPath(pathname)) return PORTAL_LOGIN_PATH;
  if (isMobileAuthPath(pathname)) return MOBILE_LOGIN_PATH;
  return WEB_LOGIN_PATH;
}

/** Écran « changer le mot de passe » (première connexion) selon le parcours. */
export function resolveFirstLoginPasswordPath(pathname) {
  if (isMobileAuthPath(pathname)) return MOBILE_FIRST_LOGIN_PASSWORD_PATH;
  return WEB_FIRST_LOGIN_PASSWORD_PATH;
}

/**
 * Connexion membre recommandée (landing, garde protégée, liens publics).
 * `preferMobile` : true sur petit écran ou parcours `/mobile/*`.
 */
export function resolveMemberLoginPath({ pathname, preferMobile } = {}) {
  const path =
    pathname || (typeof window !== 'undefined' ? window.location.pathname : '');
  if (isPortalAdminPath(path)) return PORTAL_LOGIN_PATH;
  if (preferMobile || isMobileAuthPath(path)) return MOBILE_LOGIN_PATH;
  return WEB_LOGIN_PATH;
}
